import { config } from "../config";
import { ShoppingListItem } from "../types";

export const isHttpUrl = (value: string): boolean => {
  try {
    const parsed = new URL(value);
    return parsed.protocol === "http:" || parsed.protocol === "https:";
  } catch {
    return false;
  }
};

export const normalizeLinks = (item: Pick<ShoppingListItem, "url" | "urls">): string[] => {
  const urls = Array.isArray(item.urls) ? item.urls : [];
  const legacy = item.url ? [item.url] : [];
  return [...urls, ...legacy]
    .map((value) => value?.trim())
    .filter((value, index, self) => Boolean(value) && self.indexOf(value) === index && isHttpUrl(value as string)) as string[];
};

export const buildFaviconUrl = (url: string): string => {
  const apiRoot = config.apiBaseUrl.replace(/\/$/, "");
  return `${apiRoot}/favicon?url=${encodeURIComponent(url)}`;
};
